<section class="projects-section">
    <div class="container">

        <div class="card">
            <div class="page-header">
                <h3 class="page-title">Microservices</h3>
                <div class="flex-spacer"></div>
            </div>

            <div class="table-wrapper table-mobile-card">

                <table class="table" id="microservices-table">
                    <thead>
                        <tr>
                            <th resizableColumn tableId="microservices-table" colKey="name">
                                Service Name
                            </th>

                            <th resizableColumn tableId="microservices-table" colKey="created">
                                Created At
                            </th>

                            <th resizableColumn tableId="microservices-table" colKey="updated">
                                Updated At
                            </th>

                            <th resizableColumn tableId="microservices-table" colKey="actions" class="action-col">
                                Actions
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <!-- EMPTY STATE -->
                        <tr *ngIf="microservices.length === 0">
                            <td colspan="100%">
                                <div class="no-data">
                                    <i class="fa-solid fa-diagram-project"></i>
                                    No microservices found
                                </div>
                            </td>
                        </tr>

                        <!-- DATA ROWS -->
                        <tr *ngFor="let m of microservices">

                            <td data-label="Service Name">
                                {{ m.serviceName }}
                            </td>

                            <td data-label="Created At">
                                {{ m.createdAt ? m.createdAt.split('T')[0] : '-' }}
                            </td>

                            <td data-label="Updated At">
                                {{ m.updatedAt ? m.updatedAt.split('T')[0] : '-' }}
                            </td>

                            <td data-label="Actions" class="action">
                                <button class="icon-btn settings" data-tip="Details"
                                    (click)="viewMicroservice(m.microserviceId)">
                                    <i class="fa-solid fa-gear"></i>
                                </button>
                            </td>

                        </tr>

                    </tbody>
                </table>

            </div>
        </div>

    </div>
</section>